// extracted by mini-css-extract-plugin
export default {"sectionFiveWrapper":"OurTeam_sectionFiveWrapper__Xjby-"};